// $(document).on('change', '.group_item, .select__select', function () {

// var addon_price = 0;
// $($(this).parents('.product__content-info').find('.addon_group')).each(function () {
//   if ($(this).parents('.addon_variants').is(':visible')) {
//     if ($(this).find('.group_item').is(":checked")) {
//       $(this).find('.quantity__button').removeAttr('disabled');
//       addon_price_with_qty = parseInt($(this).find('.variant_content .price').attr('data-price')) * parseInt($(this).find('[name="addon_quantity"]').val());
//       addon_price = parseInt(addon_price) + addon_price_with_qty;
//     } else {
//       $(this).find('.quantity__button').attr('disabled', true);
//     }
//   }
// });
// $('.addon_group_product .main_label .price.amount').text('$' + addon_price);
// });

document.addEventListener('change', function (event) {
  if (event.target.matches('.group_item, .select__select')) {
    let addon_price = 0;
    const productContentInfo = event.target.closest('.product__content-info');
    const addonGroups = productContentInfo.querySelectorAll('.addon_group');
    
    addonGroups.forEach(function (addonGroup) {
      const addonVariants = addonGroup.closest('.addon_variants');
      
      if (addonVariants && addonVariants.offsetParent !== null) {  // Check if visible
        const groupItem = addonGroup.querySelector('.group_item');
        
        if (groupItem.checked) {
          const quantityButton = addonGroup.querySelector('.quantity__button');
          quantityButton.removeAttribute('disabled');
          
          const priceElement = addonGroup.querySelector('.variant_content .price');
          const price = parseInt(priceElement.getAttribute('data-price'));
          const quantity = parseInt(addonGroup.querySelector('[name="addon_quantity"]').value);
          
          addon_price += price * quantity;
        } else {
          const quantityButton = addonGroup.querySelector('.quantity__button');
          quantityButton.setAttribute('disabled', true);
        }
      }
    });
    
    const priceLabel = document.querySelector('.addon_group_product .main_label .price.amount');
    if (priceLabel) {
      priceLabel.textContent = '$' + addon_price;
    }
  }
});

/* ============================================================
 * MOQ — мінімальна кількість замовлення (метаполе custom.min_quantity)
 * ------------------------------------------------------------
 * Поля кількості тема вже блокує через атрибут min (компоненти
 * quantity-input / quantity-selector). Тут — лише запобіжник:
 * перед перенаправленням на оформлення перевіряємо стан кошика
 * і, якщо є порушення мінімуму, блокуємо Checkout і показуємо
 * попередження.
 * ============================================================ */
(function () {
  var CHECKOUT_BUTTON_SELECTOR = 'button[name="checkout"]';
  var QUANTITY_INPUT_SELECTOR = '.quantity-input[data-line-key]';
  var WARNING_MESSAGE = 'El pedido mínimo para este producto es de 5 unidades.';

  function showWarning(checkoutButton) {
    var form = checkoutButton.closest('form');
    if (!form || form.querySelector('.moq-warning')) return;

    var banner = document.createElement('p');
    banner.className = 'moq-warning';
    banner.setAttribute('role', 'alert');
    banner.textContent = WARNING_MESSAGE;
    banner.style.cssText = 'background:#fef2f2;color:#b91c1c;border:1px solid #fecaca;border-radius:8px;padding:12px 16px;margin:0 0 12px;text-align:center;font-size:14px;line-height:1.4;';

    checkoutButton.insertAdjacentElement('beforebegin', banner);
  }

  function hasViolations() {
    var inputs = document.querySelectorAll(QUANTITY_INPUT_SELECTOR);
    for (var i = 0; i < inputs.length; i++) {
      var min = parseInt(inputs[i].getAttribute('min'), 10);
      var value = parseInt(inputs[i].value, 10);
      if (min && (isNaN(value) || value < min)) return true;
    }
    return false;
  }

  document.addEventListener('click', function (event) {
    var checkoutButton = event.target.closest(CHECKOUT_BUTTON_SELECTOR);
    if (!checkoutButton) return;

    var form = checkoutButton.closest('form');
    if (!form || (form.getAttribute('action') || '').indexOf('/cart') === -1) return;

    if (hasViolations()) {
      event.preventDefault();
      event.stopPropagation();
      showWarning(checkoutButton);
    }
  }, true);
})();
